module.exports = __webpack_public_path__ + "img/ali_login.198cce71.jpg";